var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricBrowser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85524,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#E9F5E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85524,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#F9FFF9",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.0351 24.4074C10.2565 26.4776 11.9207 28.1428 13.9889 28.3734C17.1657 28.7276 20.2553 28.7276 23.4321 28.3734C25.5004 28.1428 27.1645 26.4776 27.386 24.4074C27.7235 21.251 27.7235 18.17 27.386 15.0136C27.1645 12.9433 25.5004 11.2783 23.4321 11.0476C20.2553 10.6934 17.1657 10.6934 13.9889 11.0476C11.9207 11.2783 10.2565 12.9433 10.0351 15.0136C9.69758 18.17 9.69758 21.251 10.0351 24.4074Z",
    stroke: "#6BA067",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4267 15.3995H9.99473C10.008 15.2705 10.0216 15.1419 10.0353 15.0136C10.2567 12.9433 11.9209 11.2783 13.9891 11.0476C17.1659 10.6934 20.2555 10.6934 23.4323 11.0476C25.5006 11.2783 27.1648 12.9433 27.3861 15.0136C27.3998 15.1419 27.4134 15.2705 27.4267 15.3995Z",
    fill: "#DCF0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4267 15.3995H9.99473C10.008 15.2705 10.0216 15.1419 10.0353 15.0136C10.2567 12.9433 11.9209 11.2783 13.9891 11.0476C17.1659 10.6934 20.2555 10.6934 23.4323 11.0476C25.5006 11.2783 27.1648 12.9433 27.3861 15.0136C27.3998 15.1419 27.4134 15.2705 27.4267 15.3995Z",
    stroke: "#6BA067",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricBrowser);
export default __webpack_public_path__ + "static/media/MetricBrowser.531367d1a36c5fface48ed0e20479118.svg";
export { ForwardRef as ReactComponent };